import React, { FC, useState } from 'react';
import {
  Text,
  Loading,
  Icons,
  Sizes,
  SingleDatePicker,
} from '@sede-enterprise/shell-ds-react-framework';
import { Dayjs } from 'dayjs';
import { Popover, HeaderIconWrapper } from '../style';
import Button from '../../UI/Button';
import { post } from '../../services/GenesisApi';
import { sendNotification } from '../../UI/Notification';
import { GET_LATEST_NOMINATION_FROM_GEMINI } from '../../constants/Nominations';
import { getCurrentGasDay } from '../../utils/common/utils';

interface IRefreshGeminiData {
  visible: boolean;
  onPopupVisibleChange: (value: boolean) => void;
}

const { ArrowCwCircleSolid } = Icons;

const RefreshGeminiData: FC<IRefreshGeminiData> = ({
  visible,
  onPopupVisibleChange,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [gasDay, setGasDay] = useState<Dayjs | null>(getCurrentGasDay());

  const handleConfirmOnClick = () => {
    setLoading(true);
    const payload = gasDay?.format('YYYY-MM-DD');
    post(GET_LATEST_NOMINATION_FROM_GEMINI, {
      startGasDay: payload,
      endGasDay: payload,
    })
      .then(() => {
        sendNotification({
          type: 'info',
          message:
            'Fetching the latest Gemini data has started successfully and it is currently in progress',
        });
      })
      .catch(() => {
        sendNotification({
          type: 'error',
          message:
            'Failed to start the process of fetching the latest Gemini data. Please try again.',
        });
      })
      .finally(() => {
        setLoading(false);
        onPopupVisibleChange(false);
      });
  };

  const handleOnChange = (value: Dayjs | null) => {
    setGasDay(value);
  };

  return (
    <Popover
      popup={
        <div className='content'>
          <Text bold>Fetch Latest Gemini Data</Text>
          <div className='gas-day'>
            <span>Gas Day:</span>
            <SingleDatePicker
              value={gasDay}
              onChange={handleOnChange}
              allowClear={false}
            />
          </div>
          <div className='button_wrapper'>
            {loading && <Loading />}
            <Button
              size={Sizes.Small}
              variant='outlined'
              onClick={() => onPopupVisibleChange(false)}
              data-testid='btn-cancel'
            >
              Close
            </Button>
            <Button
              size={Sizes.Small}
              onClick={handleConfirmOnClick}
              data-testid='btn-confirm'
              disabled={loading}
            >
              Fetch
            </Button>
          </div>
        </div>
      }
      popupVisible={visible}
      arrow
      onPopupVisibleChange={onPopupVisibleChange}
      popupPlacement='bottomRight'
    >
      <HeaderIconWrapper>
        <ArrowCwCircleSolid />
      </HeaderIconWrapper>
    </Popover>
  );
};

export default RefreshGeminiData;
